<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<div class="p-2">
  <div class="d-flex justify-content-between align-items-center">
    <div>
      <app-search-template searchLabel="Search" [showSearchButton]=true [reset]=true [showLocations]=false
        [showDevelopments]=false [showShortTermRentals]=false [showRateBuckets]=false [showBedrooms]=false
        [showSeasons]=false [showStartDate]=true [showEndDate]=true [showSaleDateStart]=false
        [showSaleDateEnd]=false [showListingStatus]=false [showSaleYear]=false [showCustomDateRange]="true"
        [dateRange]="'pastYearFromToday'" [displayRecordsOnPageLoad]="false" (doSearchCB)="onSearchSubmit($event)">
      </app-search-template>
    </div>

    <div>
      @if (reservations?.length > 0) {
        <button pButton type="button"
          [label]="exportLoading ? 'Exporting…' : 'Export To Excel'"
          [icon]="exportLoading ? 'pi pi-spin pi-spinner' : 'pi pi-file-excel'"
          [disabled]="exportLoading"
        class="p-button-success" (click)="exportToExcel()"></button>
      }
    </div>
  </div>

  <p-table #dt [value]="reservations" [paginator]="false"
    [globalFilterFields]="['propertyCode', 'trnsInEffectiveDate', 'numBookings', 'numNtsTTL', 'avgNightlyRate']"
    responsiveLayout="scroll" [loading]="loading" styleClass="p-datatable-striped" [scrollable]="true"
    [scrollHeight]="'800px'">

    <!-- Global Search Filter -->
    <div class="p-inputgroup">
      <span class="p-inputgroup-addon"><i class="pi pi-search"></i></span>
      <input type="text" pInputText placeholder="Search..."
        (input)="dt.filterGlobal($event.target.value, 'contains')" />
    </div>

    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="propertyCode" pSticky>Property <p-sortIcon field="propertyCode"></p-sortIcon>
      </th>
      <th pSortableColumn="trnsInEffectiveDate" pSticky>Trns In Effective Date <p-sortIcon
      field="trnsInEffectiveDate"></p-sortIcon>
    </th>
    <th pSortableColumn="numBookings" pSticky>Total Bookings <p-sortIcon field="numBookings"></p-sortIcon>
  </th>
  <th pSortableColumn="avgDaysToArrival" pSticky>DTA <p-sortIcon field="avgDaysToArrival"></p-sortIcon>
</th>
<th pSortableColumn="numNtsTTL" pSticky>Nights TTL <p-sortIcon field="numNtsTTL"></p-sortIcon></th>
<th pSortableColumn="avgNightlyRate" pSticky>Avg Rate ($) <p-sortIcon field="avgNightlyRate"></p-sortIcon>
</th>
<th pSortableColumn="totalNightlyRateRev" pSticky>Total Revenue ($) <p-sortIcon
field="totalNightlyRateRev"></p-sortIcon></th>
@for (channel of channelNames; track channel) {
  <th colspan="3" style="text-align: center;" pSticky>{{ channel }}</th>
}
</tr>
<tr>
  <th></th>
  <th></th>
  <th></th>
  <th></th>
  <th></th>
  <th></th>
  <th></th>
  @for (channel of channelNames; track channel; let i = $index) {
    @if (channel === 'Total OTA Aggregate') {
      <th style="text-align: center;" pSticky>1-30 Days</th>
      <th style="text-align: center;" pSticky>1-60 Days</th>
      <th style="text-align: center;" pSticky>1-90 Days</th>
    } @else {
      @if (channel === 'Total OTA') {
        <th style="text-align: center;" pSticky>30 Days</th>
        <th style="text-align: center;" pSticky>60 Days</th>
        <th style="text-align: center;" pSticky>90 Days</th>
      } @else {
        <th style="text-align: center;" (click)="sortDataByDateRange('Last 30 Days', channel)" pSticky>
          30 Days
          <ng-container>
            <p-sortIcon [field]="'numBookings'"
              [direction]="!sortDirection || sortDirection[channel + '-Last 30 Days'] ? 'asc' : 'desc'">
            </p-sortIcon>
          </ng-container>
        </th>
        <th style="text-align: center;" (click)="sortDataByDateRange('Last 60 Days', channel)" pSticky>
          60 Days
          <ng-container>
            <p-sortIcon [field]="'numBookings'"
              [direction]="!sortDirection || sortDirection[channel + '-Last 60 Days'] ? 'asc' : 'desc'">
            </p-sortIcon>
          </ng-container>
        </th>
        <th [ngClass]="{'channel-border': i < channelNames.length - 1}" style="text-align: center;"
          (click)="sortDataByDateRange('Last 90 Days', channel)" pSticky>
          90 Days
          <ng-container>
            <p-sortIcon [field]="'numBookings'"
              [direction]="!sortDirection || sortDirection[channel + '-Last 90 Days'] ? 'asc' : 'desc'">
            </p-sortIcon>
          </ng-container>
        </th>
      }
    }
  }
</tr>
<tr>
  <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText
    type="text" (input)="dt.filter($event.target.value, 'propertyCode', 'contains')"
  placeholder="Filter"></th>
  <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText
    type="text" (input)="dt.filter($event.target.value, 'trnsInEffectiveDate', 'contains')"
  placeholder="Filter"></th>
  <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText
    type="number" (input)="dt.filter($event.target.value, 'numBookings', 'equals')"
  placeholder="Filter"></th>
  <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText
    type="number" (input)="dt.filter($event.target.value, 'avgDaysToArrival', 'equals')"
  placeholder="Filter"></th>
  <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText
    type="number" (input)="dt.filter($event.target.value, 'numNtsTTL', 'equals')" placeholder="Filter">
  </th>
  <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText
    type="number" (input)="dt.filter($event.target.value, 'avgNightlyRate', 'equals')"
  placeholder="Filter"></th>
  <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText
    type="number" (input)="dt.filter($event.target.value, 'totalNightlyRateRev', 'equals')"
  placeholder="Filter"></th>
  <th [ngStyle]="{'width': 'auto'}"></th>
</tr>
</ng-template>

<ng-template pTemplate="body" let-res>
  <tr>
    <td>{{ res.propertyCode }}</td>
    <td>{{ res.trnsInEffectiveDate }}</td>
    <td
      title="{{ res.numBookings }} Number of Booking. {{res.websiteAvgBookingPct | percent}} Website Avg Bookings / {{res.otherChannelAvgBookingPct | percent}} Other channel Avg Bookings">
      {{ res.numBookings }}({{res.websiteAvgBookingPct | percent}})/({{res.otherChannelAvgBookingPct |
      percent}})
    </td>
    <td title="Avg Days to Arrival">{{ res.avgDaysToArrival | number:'1.0-2'}}</td>
    <td title="Total Nights">{{ res.numNtsTTL | number:'1.0-0'}}</td>
    <td title="Avg Nightly Rate">{{ res.avgNightlyRate | currency : 'USD' : 'symbol' : '1.0-0' }}</td>
    <td title="Total Revenue">{{ res.totalNightlyRateRev | currency : 'USD' : 'symbol' : '1.0-0' }}</td>

    @for (channel of channelNames; track channel; let i = $index) {
      @if (channel === 'Total OTA Aggregate') {
        <!-- Insert Total OTA Aggregate after Website -->
        <td style="text-align: left;"
          [ngStyle]="{'color': res.totalOtaBookingsUpto30Days > 0 ? 'green' : 'red'}"
          [title]="getTotalOTATooltipText(res, channel, 'Last 30 Days')">
          {{ res.totalOtaBookingsUpto30Days || 0 }}
          <div [ngStyle]="{'color': res.totalOtaAvgDaysToArrivalUpto30Days > 0 ? 'green' : 'red'}">
          {{ res.totalOtaAvgDaysToArrivalUpto30Days || 0 | number:'1.0-0' }}d</div>
          <div [ngStyle]="{'color': res.totalOtaNtsTTLUpto30Days > 0 ? 'green' : 'red'}">
          {{ res.totalOtaNtsTTLUpto30Days || 0 }}d</div>
          <div [ngStyle]="{'color': res.totalOtaAvgRateUpto30Days > 0 ? 'green' : 'red'}">
            {{ (res.totalOtaAvgRateUpto30Days || 0) | currency:'USD':'symbol':'1.0-0' }}
          </div>
          <div [ngStyle]="{'color': res.totalOtaRevUpto30Days > 0 ? 'green' : 'red'}">
            {{ (res.totalOtaRevUpto30Days || 0) | currency:'USD':'symbol':'1.0-0' }}
          </div>
        </td>
        <td style="text-align: left;"
          [ngStyle]="{'color': res.totalOtaBookingsUpto60Days > 0 ? 'green' : 'red'}"
          [title]="getTotalOTATooltipText(res, channel, 'Last 60 Days')">
          {{ res.totalOtaBookingsUpto60Days || 0 }}
          <div [ngStyle]="{'color': res.totalOtaAvgDaysToArrivalUpto60Days > 0 ? 'green' : 'red'}">
          {{ res.totalOtaAvgDaysToArrivalUpto60Days || 0 | number:'1.0-0' }}d</div>
          <div [ngStyle]="{'color': res.totalOtaNtsTTLUpto60Days > 0 ? 'green' : 'red'}">
          {{ res.totalOtaNtsTTLUpto60Days || 0 }}d</div>
          <div [ngStyle]="{'color': res.totalOtaAvgRateUpto60Days > 0 ? 'green' : 'red'}">
            {{ (res.totalOtaAvgRateUpto60Days || 0) | currency:'USD':'symbol':'1.0-0' }}
          </div>
          <div [ngStyle]="{'color': res.totalOtaRevUpto60Days > 0 ? 'green' : 'red'}">
            {{ (res.totalOtaRevUpto60Days || 0) | currency:'USD':'symbol':'1.0-0' }}
          </div>
        </td>
        <td style="text-align: left;" [ngClass]="{'channel-border': i < channelNames.length - 1}"
          [ngStyle]="{'color': res.totalOtaBookingsUpto90Days > 0 ? 'green' : 'red'}"
          [title]="getTotalOTATooltipText(res, channel, 'Last 90 Days')">
          {{ res.totalOtaBookingsUpto90Days || 0 }}
          <div [ngStyle]="{'color': res.totalOtaAvgDaysToArrivalUpto90Days > 0 ? 'green' : 'red'}">
          {{ res.totalOtaAvgDaysToArrivalUpto90Days || 0 | number:'1.0-0' }}d</div>
          <div [ngStyle]="{'color': res.totalOtaNtsTTLUpto90Days > 0 ? 'green' : 'red'}">
          {{ res.totalOtaNtsTTLUpto90Days || 0 }}d</div>
          <div [ngStyle]="{'color': res.totalOtaAvgRateUpto90Days > 0 ? 'green' : 'red'}">
            {{ (res.totalOtaAvgRateUpto90Days || 0) | currency:'USD':'symbol':'1.0-0' }}
          </div>
          <div [ngStyle]="{'color': res.totalOtaRevUpto90Days > 0 ? 'green' : 'red'}">
            {{ (res.totalOtaRevUpto90Days || 0) | currency:'USD':'symbol':'1.0-0' }}
          </div>
        </td>
      } @else {
        @if (channel === 'Total OTA') {
          <td style="text-align: left;" [title]="getTotalOTATooltipText(res, channel, 'Last 30 Days')">
            <div [ngStyle]="{'color': (res.totalOtaBookings30Days || 0) > 0 ? 'blue' : 'inherit'}">
              {{ res.totalOtaBookings30Days || 0 }}
            </div>
            <div
              [ngStyle]="{'color': (res.totalOtaAvgDaysToArrival30Days || 0) > 0 ? 'blue' : 'inherit'}">
              {{ res.totalOtaAvgDaysToArrival30Days || 0 | number:'1.0-0' }}d
            </div>
            <div [ngStyle]="{'color': (res.totalOtaNtsTTL30Days || 0) > 0 ? 'blue' : 'inherit'}">
              {{ res.totalOtaNtsTTL30Days || 0 }}d
            </div>
            <div [ngStyle]="{'color': (res.totalOtaAvgRate30Days || 0) > 0 ? 'blue' : 'inherit'}">
              {{ (res.totalOtaAvgRate30Days || 0) | currency:'USD':'symbol':'1.0-0' }}
            </div>
            <div [ngStyle]="{'color': (res.totalOtaRev30Days || 0) > 0 ? 'blue' : 'inherit'}">
              {{ (res.totalOtaRev30Days || 0) | currency:'USD':'symbol':'1.0-0' }}
            </div>
          </td>
          <td style="text-align: left;" [title]="getTotalOTATooltipText(res, channel, 'Last 60 Days')">
            <div [ngStyle]="{'color': (res.totalOtaBookings60Days || 0) > 0 ? 'blue' : 'inherit'}">
              {{ res.totalOtaBookings60Days || 0 }}
            </div>
            <div
              [ngStyle]="{'color': (res.totalOtaAvgDaysToArrival60Days || 0) > 0 ? 'blue' : 'inherit'}">
              {{ res.totalOtaAvgDaysToArrival60Days || 0 | number:'1.0-0' }}d
            </div>
            <div [ngStyle]="{'color': (res.totalOtaNtsTTL60Days || 0) > 0 ? 'blue' : 'inherit'}">
              {{ res.totalOtaNtsTTL60Days || 0 }}d
            </div>
            <div [ngStyle]="{'color': (res.totalOtaAvgRate60Days || 0) > 0 ? 'blue' : 'inherit'}">
              {{ (res.totalOtaAvgRate60Days || 0) | currency:'USD':'symbol':'1.0-0' }}
            </div>
            <div [ngStyle]="{'color': (res.totalOtaRev60Days || 0) > 0 ? 'blue' : 'inherit'}">
              {{ (res.totalOtaRev60Days || 0) | currency:'USD':'symbol':'1.0-0' }}
            </div>
          </td>
          <td style="text-align: left;" [ngClass]="{'channel-border': i < channelNames.length - 1}"
            [title]="getTotalOTATooltipText(res, channel, 'Last 90 Days')">
            <div [ngStyle]="{'color': (res.totalOtaBookings90Days || 0) > 0 ? 'blue' : 'inherit'}">
              {{ res.totalOtaBookings90Days || 0 }}
            </div>
            <div
              [ngStyle]="{'color': (res.totalOtaAvgDaysToArrival90Days || 0) > 0 ? 'blue' : 'inherit'}">
              {{ res.totalOtaAvgDaysToArrival90Days || 0 | number:'1.0-0' }}d
            </div>
            <div [ngStyle]="{'color': (res.totalOtaNtsTTL90Days || 0) > 0 ? 'blue' : 'inherit'}">
              {{ res.totalOtaNtsTTL90Days || 0 }}d
            </div>
            <div [ngStyle]="{'color': (res.totalOtaAvgRate90Days || 0) > 0 ? 'blue' : 'inherit'}">
              {{ (res.totalOtaAvgRate90Days || 0) | currency:'USD':'symbol':'1.0-0' }}
            </div>
            <div [ngStyle]="{'color': (res.totalOtaRev90Days || 0) > 0 ? 'blue' : 'inherit'}">
              {{ (res.totalOtaRev90Days || 0) | currency:'USD':'symbol':'1.0-0' }}
            </div>
          </td>
        } @else {
          <!-- Loop for Last 30, 60, 90 Days -->
          @for (period of ['Last 30 Days', 'Last 60 Days', 'Last 90 Days']; track period) {
            <td [ngClass]="{'channel-border': period === 'Last 90 Days' && i < channelNames.length - 1}"
              style="text-align: left;" [title]="getTooltipText(res, channel, period)">
              <!-- Capture data or use default fallback -->
              <!-- <ng-container *ngIf="res.channelMap[channel + '-' + period] as data; else zeroData">
              {{ data.numBookings || 0 }}
              ({{ data.avgDaysToArrival || 0 | number:'1.0-0'}}d)
              ({{ data.numNtsTTL || 0 }}d)
              ${{ (data.avgNightlyRate || 0) | currency:'USD':'symbol':'1.0-0' }}
              ({{ (data.totalNightlyRateRev || 0) | currency:'USD':'symbol':'1.0-0' }})
            </ng-container> -->
            @if (res.channelMap[channel + '-' + period]; as data) {
              <div [ngStyle]="{'color': data.numBookings > 0 ? 'blue' : 'inherit'}">
                {{ data.numBookings || 0 }}
              </div>
              <div [ngStyle]="{'color': data.avgDaysToArrival > 0 ? 'blue' : 'inherit'}">
                {{ data.avgDaysToArrival || 0 | number:'1.0-0'}}d
              </div>
              <div [ngStyle]="{'color': data.numNtsTTL > 0 ? 'blue' : 'inherit'}">
                {{ data.numNtsTTL || 0 }}d
              </div>
              <div [ngStyle]="{'color': data.avgNightlyRate > 0 ? 'blue' : 'inherit'}">
                {{ (data.avgNightlyRate || 0) | currency:'USD':'symbol':'1.0-0' }}
              </div>
              <div [ngStyle]="{'color': data.totalNightlyRateRev > 0 ? 'blue' : 'inherit'}">
                {{ (data.totalNightlyRateRev || 0) | currency:'USD':'symbol':'1.0-0' }}
              </div>
            } @else {
              <div>
                0
              </div>
              <div>
                0d
              </div>
              <div>
                0d
              </div>
              <div>
                $0
              </div>
              <div>
                0
              </div>
            }
            <!-- Fallback template -->
          </td>
        }
      }
    }
  }
</tr>
</ng-template>
</p-table>
</div>